import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {first, map, take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {cities, djangourl} from '../../../assets/urls';
import {faCalendar} from '@fortawesome/free-solid-svg-icons';
import {timer} from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;
  phoneForm: FormGroup;
  codeForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  success = '';
  recaptcha?: string;
  token: string;
  smsSend = false;
  registerUrl = djangourl + 'api/signup/';
  getcoderUrl = djangourl + 'api/sms/get';
  sendcoderUrl = djangourl + 'api/sms/confirm';
  user: any;
  states = cities;
  selectedState = {
    name: '',
    Cities: [{name: ''}]
  };
  date = faCalendar;
  countDown;
  counter = 60;
  tick = 1000;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';


    this.registerForm = this.formBuilder.group({
      password1: ['', Validators.required],
      password2: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.email],
      address: ['', Validators.required],
      postal_code: ['', Validators.required],

      birth: [''],
      nbirth: [''],
      state: ['تهران'],
      city: ['تهران'],
      race: ['fars'],
      gender: [''],

    });
    this.selectState();
    this.rf.city.setValue('تهران');

    this.rf.nbirth.setValue({
      year: parseInt(this.rf.birth.value.split('-')[0]),
      month: parseInt(this.rf.birth.value.split('-')[1]),
      day: parseInt(this.rf.birth.value.split('-')[2])
    });


    this.phoneForm = this.formBuilder.group({
      phone: ['', Validators.pattern('^((\\\\09-?)|0)?[0-9]{11}$')],
      recaptcha: ['']
    });

    this.codeForm = this.formBuilder.group({
      code: ['', Validators.required]
    });

     this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';

     const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'visible';
    }
  }

  get rf() {
    return this.registerForm.controls;
  }

  get pf() {
    return this.phoneForm.controls;
  }

  get cf() {
    return this.codeForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.error = '';
    if (!this.rf.nbirth.value['year']) {
      this.error +=  '*   لطفا تاریخ تولد خود را وارد کنید' + '\n';
    }
    if (this.rf.gender.value === '') {

      this.error += '*   لطفا جنسیت را انتخاب کنید' + '\n';
    }
    if (this.registerForm.invalid) {
      return;
    }

    if (this.rf.password1.value !== this.rf.password2.value) {
      this.error = 'کلمه عبور و تکرار کلمه عبور یکسان نمی باشند';
      return;
    }
    this.user = {
      first_name: this.rf.first_name.value,
      last_name: this.rf.last_name.value,
      email: this.rf.email.value,
      password: this.rf.password1.value,
      address: this.rf.address.value,
      postal_code: this.rf.postal_code.value,
      token: this.token,
      phone: this.pf.phone.value,
      birth: this.rf.nbirth.value['year'] + '-' + this.rf.nbirth.value['month'] + '-' + this.rf.nbirth.value['day'],
      gender: this.rf.gender.value,
      race: this.rf.race.value,
      city: this.rf.city.value,
      state: this.rf.state.value,
    };

    this.loading = true;
    this.http.post(this.registerUrl, this.user, {headers: {}}).subscribe(data => {
      this.success = 'حساب کاربری شما موفقیت ایجاد شد';
      this.loading = false;
      this.submitted = false;

      this.authenticationService.login(this.user.phone, this.user.password)
        .pipe(first())
        .subscribe(
          data2 => {
            // if (data['role'] === 'Admin') {
            //   this.router.navigate(['/admin']);
            // } else if (data['role'] === 'User') {
            //   this.router.navigate(['/user']);
            // } else {
            //   this.router.navigate(['/']);
            // }
            if (this.returnUrl.length > 1) {
              this.router.navigateByUrl(this.returnUrl);
            } else {
              //this.router.navigate(['login']);

            }
          },
          error => {

            this.error = error;
            this.loading = false;
          });


    }, error => {
      this.error = error;
      this.loading = false;
    });
  }

  selectState() {
    const state = this.rf.state.value;
    let c;
    this.states.forEach(function (value) {
      if (value.name === state) {
        c = value;
      }
    });
    this.rf.city.setValue('');
    this.selectedState = c;

  }

  submitPhoneNumber() {
    this.submitted = true;
    this.error = '';
    if (!this.pf.phone.value) {
      this.error = 'لطفا شماره موبایل را کامل کنید';
      return;
    }

  

    const pnumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const anumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    const enumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];


    let phone = this.pf.phone.value;
    for (let i = 0; i < pnumbers.length; i++) {
      const regex1 = new RegExp(pnumbers[i], 'g');
      const regex2 = new RegExp(anumbers[i], 'g');
      phone = phone.replace(regex1, enumbers[i]);
      phone = phone.replace(regex2, enumbers[i]);
    }

    this.pf.phone.setValue(phone);
    if (this.phoneForm.invalid) {
      return;
    }

    this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
      const prequest = {
        phone: this.pf.phone.value,
        recaptcha: token,
        new: true
      };
  
      this.loading = true;
      this.http.post(this.getcoderUrl, prequest, {headers: {}}).subscribe(data => {
        this.loading = false;
  
        if (data['error']) {
          this.error = data['message'];
          return;
        }
        this.smsSend = true;
        this.submitted = false;
        this.countDown = timer(0, this.tick).pipe(map(() => --this.counter), take(this.counter));
  
  
      }, error => {
        this.error = error;
        this.loading = false;
      });
  
    });

    
  }


  resendCode() {

    const prequest = {
      phone: this.pf.phone.value,
      new: false
    };

    this.loading = true;
    this.http.post(this.getcoderUrl, prequest, {headers: {}}).subscribe(data => {
      this.loading = false;

      if (data['error']) {
        this.error = data['message'];
        return;
      }

      this.counter = 60;
      this.countDown = timer(0, this.tick).pipe(map(() => --this.counter), take(this.counter));


      this.smsSend = true;
      this.submitted = false;

    }, error => {
      this.error = error;
      this.loading = false;
    });

  }

  submitCode() {
    this.submitted = true;
    this.error = '';
    if (this.codeForm.invalid) {
      return;
    }
    const code = {
      phone: this.pf.phone.value,
      pin: parseInt(this.cf.code.value, 10),

    };

    this.loading = true;
    this.http.post(this.sendcoderUrl, code, {headers: {}}).subscribe(data => {
      this.loading = false;

      if (data['error']) {
        this.error = data['message'];
        return;
      }
      this.submitted = false;

      this.smsSend = true;
      this.token = data['token'];
      this.loading = false;
    }, error => {
      this.error = error;

      this.loading = false;
    });

  }

  ngOnDestroy() {
   
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'hidden';
    }
  }


}

@Pipe({
  name: 'formatTime'
})

export class FormatTimePipe implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
  }

}
